export default __webpack_public_path__ + "static/media/logo.30ba76b3.png";